export var DashboardsRoutes = {
    "/dashboard": {
        "name": "appLayout.harriSH.dashboard",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Dashboard"
            }
        ],
        "params": {
            brand: null,
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./../../hmodules/interview-video/interview-video.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/job-approval/job-approval.module.js');
                }
            }
        ],
        "resolve": {
            dashboardRedirectionChecks: ['$q', '$timeout', '$state', 'userPreferencesManagerService', ($q, $timeout, $state, userPreferencesManagerService) => {
                const defer = $q.defer();

                userPreferencesManagerService.getDashboardRoute()
                    .then((homePageRoute) => {
                        if (homePageRoute.isUrl || homePageRoute.redirectToWorkspace) {
                            window.location.href = homePageRoute.href;
                        } else {
                            $timeout(() => {
                                $state.go(homePageRoute.name, homePageRoute.params);
                            });
                        }
                        defer.resolve(false);
                    })
                    .catch((err) => {
                        console.error(err);
                        defer.resolve(true);
                    });

                return defer.promise;
            }],
        },
        "onEnter": ['$transition$', '$location', '$timeout', function ($transition$, $location, $timeout) {
            var toState = $transition$.to();

            if (toState && toState.name === 'appLayout.harriSH.dashboard') {
                $timeout(function () {
                    $location.search('gid', null);
                });
            }
        }],
    },
    "/dashboard/tts": {
        "name": "appLayout.harriSH.dashboard-tts",
        "analytics_name": "dashboard-tts",
        "type": "frontend",
        "showGlobalSearch": true,
        "component":"ttsDashboardPage",
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Dashboard"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./../../hmodules/interview-video/interview-video.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/job-approval/job-approval.module.js');
                }
            }
        ],
    },
    "/dashboard/member?consentDataCleanseBrandId": {
        "name": "dashboard-member",
        "loginRequired": true,
        "analytics_name": "dashboard-member",
        "component":"memberDashboardPage",
        "type": "frontend",
        "showGlobalSearch": true,
        "params": {
            consentDataCleanseBrandId: {dynamic: true}
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Dashboard"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../hmodules/right-to-work/right-to-work.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/outmatch-assessment/outmatch-assessment.module.js');
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("./../../hmodules/interview-video/interview-video.module.js");
                }
            }
        ],
    },
    "/dashboard/hiring?brand": {
        "name": "appLayout.harriSH.dashboard-hiring",
        "analytics_name": "dashboard-hiring",
        "type": "frontend",
        "component": "hiringDashboardPage",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            brand: null
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Dashboard"
            }
        ],
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"},
            {
                type: 'chunk',
                loader: function () {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/talent-pool/talent-pool.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/job-approval/job-approval.module.js');
                }
            }
        ],
        "resolve": {
            dashboardData: ['httpHelper', 'hUser', function (httpHelper, hUser) {
                return httpHelper.g("groups/" + hUser.getUserContext().brand_id + "/employer/dashboard_data");

            }]
        },
        "onEnter": ['$state', 'hUser', function ($state, hUser) {
            if (!hUser.isEmployer()) {
                hRedirect('/404');
            }

            if (hUser.isTopLevelContext()) {
                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
            }
        }]
    },
    "/job-repost/:job_id?pjt": {
        "name": "appLayout.harriSH.dashboard.job-repost",
        "type": "frontend",
        "modal": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "loginRequired": true,
        "views": {
            "job-repost": {
                "component": "dashboardJobRepost"
            }
        }
    },
    "/job-post/:job_id?pjt": {
        "name": "appLayout.harriSH.dashboard.job-post",
        "type": "frontend",
        "modal": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "loginRequired": true,
        "views": {
            "job-repost": {
                "component": "dashboardJobRepost"
            }
        }
    },
    "/job-boost/:job_id?pjt": {
        "name": "appLayout.harriSH.dashboard.job-boost",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "modal": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "views": {
            "job-repost": {
                "component": "dashboardJobRepost"
            }
        }
    },
    "/on-boarding?prospect_id&showOBDocumentsModal": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH.on-boarding",
        "type": "frontend",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Onboarding"
            }
        ],
        "component": "onboardingDashboardPage",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./dashboards.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/job-approval/job-approval.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../hmodules/hyper-hire/hyperhire.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/wotc/wotc.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../hmodules/on-boarding/on-boarding.module.js");
                }
            }
        ],
        onEnter: ['$state', 'hUser', 'brandServices', async ($state, hUser, brandServices) => {
            try {
                const isOnBoardingJourneyEnabled = await brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, hUser.getUserContext().brand_id)
                if (isOnBoardingJourneyEnabled || hUser.isTopLevelContext()) {
                    Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                    return false;
                } else {
                    const policies = await UserAPI.getUserPolicies(hUser.getUserContext().brand_id)
                    if (!policies?.services?.length || !policies.services.includes('ON_BOARDING')) {
                        hRedirect("/404")
                        return false
                    }
                }
                return true;
            } catch (e) {
                console.error(e);
            }
        }]
    },
    // Duplicate is a work around added by Afaneh to allow setting two URL's with same key in the JSON
    // Replaced in DispatcherModule
    "||||DUPLICATE||||/job-repost/:job_id?pjt": {
        "name": "appLayout.harriSH.dashboard-hiring.job-repost",
        "type": "frontend",
        "modal": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "loginRequired": true,
        "views": {
            "job-repost": {
                "component": "dashboardJobRepost"
            }
        }
    },
    // Duplicate is a work around added by Afaneh to allow setting two URL's with same key in the JSON
    // Replaced in DispatcherModule
    "||||DUPLICATE||||/job-boost/:job_id?pjt": {
        "name": "appLayout.harriSH.dashboard-hiring.job-boost",
        "type": "frontend",
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "modal": true,
        "views": {
            "job-repost": {
                "component": "dashboardJobRepost"
            }
        }
    },
    // Duplicate is a work around added by Afaneh to allow setting two URL's with same key in the JSON
    // Replaced in DispatcherModule
    "||||DUPLICATE||||/job-post/:job_id?pjt": {
        "name": "appLayout.harriSH.dashboard-hiring.job-post",
        "type": "frontend",
        "loginRequired": true,
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "showGlobalSearch": true,
        "modal": true,
        "views": {
            "job-repost": {
                "component": "dashboardJobRepost"
            }
        }
    },
};
